
<template>

    <div>
         <div class="MultipleSelectBox"
             ControlType="MultipleSelectBox"
             v-show="m_Attribute.Visible"
             :nullable="(!m_Attribute.Required)+''"
         >
            <div class="BoxContainer Left">

                <div class="Title" v-show="this.LeftTitle != null" v-html="LeftTitle"></div>
                <div class="ButtonList">
                    <t-button class="Button MoveAllToRight Original"
                              style="border-right:none"
                               :disabled="(!m_Attribute.Enabled)"
                              @click="OnMoveAllToRightButtonClick">&gt;&gt;</t-button>
                    <t-button class="Button MoveToRight Original"
                              :disabled="LeftSelectedValues.length == 0 || 
                              (!m_Attribute.Enabled)"
                              @click="OnMoveToRightButtonClick">&gt;</t-button>
                </div>



                <select class="Box Field" multiple v-model="LeftSelectedValues"
                        ref="LeftSelect"
                        >

                    <option v-for="(option,index) in this.UnselectedOptions"
                            :value="option.Value"
                             :disabled="!GetOptionAbility(option)"
                             style="{color:option.Color}"
                            >
                        <template v-if="LeftOptionTextRender != null">
                            {{LeftOptionTextRender(option)}}
                        </template>
                        <template v-else>
                            {{option.Text}}
                        </template>
                    </option>
                </select>
            </div>
            <div class="BoxContainer Right">

                <div class="Title" v-show="this.RightTitle != null" v-html="RightTitle"></div>

                <div class="ButtonList">
                    <t-button class="Button MoveToLeft Original"
                              style="border-right:none"
                              :disabled="RightSelectedValues.length == 0 || this.disabled == true"
                              @click="OnMoveToLeftButtonClick">&lt;</t-button>
                    <t-button class="Button MoveAllToLeft Original"
                                :disabled="this.disabled == true"
                              @click="OnMoveAllToLeftButtonClick">&lt;&lt;</t-button>

                </div>
                <select class="Box Field" multiple
                        v-model="RightSelectedValues"
                        ref="RightSelect">

                    <option v-for="(option,index) in this.SelectedOptions"
                            :value="option.Value">
                        <template v-if="RightOptionTextRender != null">
                            {{RightOptionTextRender(option)}}
                        </template>
                        <template v-else>
                            {{option.Text}}
                        </template>
                    </option>
                </select>
            </div>


        </div>
    </div>
    



</template>

<script scoped>
    import TControlBase from '@/Common/TControlBase';
    import Utility from '@/Common/Utility';
    import FieldOptionService from '@/Common/FieldOptionService';
 
    export default {
        name: "t-multipleselectbox",
        data() {
            return {
                m_RepeatColumns: 1000,
                SourceValueType: "String", //String or Array
                CheckedValues: [],
                LeftSelectedValues: [],
                RightSelectedValues: [],
                m_Attribute: TControlBase.Attribute({
                    Options: []
                })
            }
        }
        ,
        props: [

            "Name" ,
            "value", "Attribute", "RepeatColumns",
            "Options",
            "Visible" ,
            "OptionName", "ComplexOptionName", "CacheOption",
            "OptionAbilityHandler",
            "LeftSortOptionHandler",
            "RightSortOptionHandler",
            "LeftOptionTextRender", "RightOptionTextRender",
            "ConfirmMoveToRightHandler",
            "MoveToRightConfirmHandler",
            "LeftTitle",
            "RightTitle",
            "disabled",  
        ],


        computed: {

            //Options: function () {
            //    let options = [];
 
            //    if (this.Attribute != null && this.Attribute.Options != null) {
            //        options = this.Attribute.Options;
            //    }

            //    if (this.m_Attribute.Options.length > 0) {
            //        options.push(...this.m_Attribute.Options);
            //    }

            //    return options;
            //},

            //Disabled: function () {
            //    let result = false;

            //    if (this.Attribute != null && this.Attribute.Enabled != null) {
            //        result = !this.Attribute.Enabled;
            //    }

            //    return result;
            //}
            //,
            //CssClass: function () {
            //    let result = "";


            //    if (this.Attribute != null && this.Attribute.CssClass != null) {
            //        result = this.Attribute.CssClass;
            //    }

            //    return result;
            //}
            //,


            //ReadOnly: function () {

            //    let result = false;


            //    if (this.Attribute != null && this.Attribute.ReadOnly != null) {
            //        result = this.Attribute.ReadOnly;
            //    }

            //    return result;
            //}

        }
        ,

        methods: {

 
         
            OnMoveAllToRightButtonClick() {
                let leftSelectedValues = [];
                let selectedOptions = [];
                let selectedValue;
                let options = [];
                let i;


                leftSelectedValues.push(...this.LeftSelectedValues);
                selectedOptions.push(...this.UnselectedOptions);

                options.push(...this.UnselectedOptions);


 
                if (this.MoveToRightConfirmHandler != null) {
                    let result;

                    for (i = 0; i < this.m_Attribute.Options.length; i++) {
                        let option;

                        option = this.m_Attribute.Options[i];

                        if (this.GetOptionAbility(option)) {
                            if (leftSelectedValues.indexOf(option.Value) >= 0) {
                                selectedOptions.push(option);
                            }
                        }
                    }
                     
                    if (selectedOptions.length > 0) {
                        result = this.MoveToRightConfirmHandler(selectedOptions).then(
                            function (result) {
                                let i;
                                 
                                if (result == true) {
                                    for (i = 0; i < options.length; i++) {
                                        selectedValue = options[i].Value;
                                        if (this.CheckedValues.indexOf(selectedValue) < 0) {
                                            this.CheckedValues.push(selectedValue);
                                        }
                                    }

                                    Utility.TouchArray(this.m_Attribute.Options);


                                    this.LeftSelectedValues = [];
                                    this.$forceUpdate();

                                    this.OnValueChange();
                                }//end  if (result == true) {
                            }.bind(this)
                        );

                        return;
                    }
                    
                }//end if (this.MoveToRightConfirmHandler != null) {


                for (i = 0; i < options.length; i++) {
                    selectedValue = options[i].Value;

                    if (this.GetOptionAbility(options[i])) {

                        if (this.CheckedValues.indexOf(selectedValue) < 0) {
                            this.CheckedValues.push(selectedValue);
                        }
                    }
                }

                Utility.TouchArray(this.m_Attribute.Options);


                this.LeftSelectedValues = [];
                this.$forceUpdate();

                this.OnValueChange();
            },//end OnMoveAllToRightButtonClick() {


            OnMoveToRightButtonClick() {
                let leftSelectedValues = [];
                let selectedOptions = [];
                let selectedValue;
                let i;


                leftSelectedValues.push(...this.LeftSelectedValues);


                if (this.MoveToRightConfirmHandler != null) {
                  
                    for (i = 0; i < this.m_Attribute.Options.length; i++) {
                        let option;

                        option = this.m_Attribute.Options[i];

                        if (leftSelectedValues.indexOf(option.Value) >= 0) {
                            selectedOptions.push(option);
                        }
                    }

                    this.MoveToRightConfirmHandler(selectedOptions).then(
                        function (result) {
                            if (result == true) {
                                for (i = 0; i < leftSelectedValues.length; i++) {
                                    selectedValue = leftSelectedValues[i];
                                    if (this.CheckedValues.indexOf(selectedValue) < 0) {
                                        this.CheckedValues.push(selectedValue);
                                    }
                                }

                                Utility.TouchArray(this.m_Attribute.Options);

                                this.LeftSelectedValues = [];

                                this.$forceUpdate();

                                this.OnValueChange();
                            }//end if (result == true) {
                        }.bind(this)
                    );


                    return;
                }

                for (i = 0; i < leftSelectedValues.length; i++) {
                    selectedValue = leftSelectedValues[i];
                    if (this.CheckedValues.indexOf(selectedValue) < 0) {
                        this.CheckedValues.push(selectedValue);
                    }
                }

                Utility.TouchArray(this.m_Attribute.Options);

                this.LeftSelectedValues = [];

                this.$forceUpdate();

                this.OnValueChange();
            },//end OnMoveToRightButtonClick() {


            OnMoveAllToLeftButtonClick() {
                let selectedValue;
                let options = [];
                let i;

             
                Utility.TouchArray(this.m_Attribute.Options);

                this.CheckedValues.length = 0;

                this.RightSelectedValues = [];

                this.OnValueChange();
                this.$forceUpdate();
            },//end OnMoveAllToLeftButtonClick() {


            OnMoveToLeftButtonClick() {
                let selectedValue;
                let options = [];
                let newCheckedValues = [];
                let i;

 
                for (i = 0; i < this.RightSelectedValues.length; i++) {
                    let value;

                    value = this.RightSelectedValues[i];

                    Utility.RemoveArrayElement(this.CheckedValues, value);
                }

                Utility.TouchArray(this.m_Attribute.Options);


                this.OnValueChange();
                this.$forceUpdate();
            },//end OnMoveToRightButtonClick() {




            OnValueChange(e) {
                let checkValues = [];
                let resultValue = "";
                let i;


                for (i = 0; i < this.CheckedValues.length; i++) {
                    if (this.CheckedValues[i] != "" && this.CheckedValues[i] != null) {
                        checkValues.push(this.CheckedValues[i]);
                    }
                }

                if (this.SourceValueType == "String") {
                    resultValue = checkValues.join(",");
                }
                else {
                    resultValue = checkValues;
                }

                this.$emit("input", resultValue);

                this.$emit("change", resultValue);
            },

            ToggleCheckValue(optionValue) {
                let index;

                if ((index = this.CheckedValues.indexOf(optionValue)) >= 0) {
                    this.CheckedValues.splice(index, 1);
                }
                else {
                    this.CheckedValues.push(optionValue);
                }

                this.OnValueChange();
            },

            UpdateElementByAttribute() {

            },


            //�N�� TControlBase �I�s
            ResetValue() {
            }
        },

        mounted() {
            this.DoOnMounted();
        },

        beforeMounted() {

        },

        created() {

            TControlBase.call(this);

            this.UpdateElementByAttribute();

            if (this.value != null && this.value != "") {
                if (typeof (this.value) == "string") {
                    this.SourceValueType = "String";
                    this.CheckedValues = this.value.split(",")
                }
                else {
                    this.SourceValueType = "Array";
                    if (newVal != null) {
                        this.CheckedValues = this.value;
                    }
                }
            }

 
             
            
        },

        watch: {
            value: function (newVal, oldVal) {
 
                if (newVal == null) {
                    this.SourceValueType = "String";
                    this.CheckedValues.length = 0;
                }
                else if (typeof (newVal) == "string") {
                    this.SourceValueType = "String";
                    this.CheckedValues = newVal.split(",")
                }
                else {
                    this.SourceValueType = "Array";
                    if (newVal != null) {
                        this.CheckedValues = newVal;
                    }
                }


   
                this.$forceUpdate();

                if (this.$refs.LeftSelect != null) {
                    this.$refs.LeftSelect.scrollTop = 0;
                }

                if (this.$refs.RightSelect != null) {
                    this.$refs.RightSelect.scrollTop = 0;
                }
            },

            Attribute: function () {
                this.UpdateElementByAttribute();
            },

            Options: function (newVal, oldVal) {


                this.m_Attribute.Options = newVal;
                
                this.$forceUpdate();
            },

        },


        computed: {

            //#region UnselectedOptions
            UnselectedOptions: {
                get() {
                    let options = [];
                    let option = {};
                    let i;

                    if (this.m_Attribute.Options != null) {
                        for (i = 0; i < this.m_Attribute.Options.length; i++) {
                            option = this.m_Attribute.Options[i];

                            if (this.CheckedValues.indexOf(option.Value) < 0) {
                                options.push(option);
                            }
                        }

                    }


                    if (this.LeftSortOptionHandler != null) {
                        options.sort(this.LeftSortOptionHandler);
                    }
                    else if (this.SortOptionHandler != null) {
                        options.sort(this.SortOptionHandler);
                    }

                    return options;
                },
            },

            //#endregion UnselectedOptions


            //#region SelectedOptions
            SelectedOptions: {
                get() {
                    let options = [];
                    let option = {};
                    let i;

                    
                    if (this.m_Attribute.Options != null) {
                 
                        for (i = 0; i < this.m_Attribute.Options.length; i++) {
                            option = this.m_Attribute.Options[i];

                            if (this.CheckedValues.indexOf(option.Value) >= 0) {
                                options.push(option);
                            }
                        }
                    } 

                    if (this.RightSortOptionHandler != null) {
                        options.sort(this.RightSortOptionHandler);
                    }
                    else if (this.SortOptionHandler != null) {
                        options.sort(this.SortOptionHandler);
                    }
                     
                    return options;
                },
            },
            //#endregion
        }//end computed: {




    }
</script>

<style scoped>

    .MultipleSelectBox
    {
        display:flex;
        flex-flow:row;
        justify-content:space-between;
    }

    .MultipleSelectBox .BoxContainer{
        flex-basis:48%;
        flex-grow:0; 

    }

     .MultipleSelectBox .BoxContainer select.Box{
         overflow-y:auto;
     }

    .BoxContainer .ButtonList
    {
        display:flex;
        flex-direction:row;
        justify-content:space-between;
    }

    .BoxContainer .ButtonList .Button{
        flex-grow:0;
        box-sizing:border-box;
        flex-basis:50%;
        line-height:30PX;
    }


    Select.Box.Field
    {
        height:150px!important;
    }

    .Button.Original{
        border-bottom:none;
    }

    select option[disabled]{
        color:#909090;
        cursor:text;
    }
</style>
